import ResolutionTools from "../components/ResolutionTools/ResolutionTools.jsx";
import ColorControls from "../components/ColorControls/ColorControls.jsx";
import ExportElementsPremiere from "../components/ExportElementsPremiere/ExportElementsPremiere.jsx";
import Markers from "../components/Markers/Markers.jsx";
import MotionAnimator from "../components/MotionAnimator/MotionAnimator.jsx";
import EaseAnimator from "../components/EaseAnimator/EaseAnimator.jsx";
import RandomAnimator from "../components/RandomAnimator/RandomAnimator.jsx";
import RenderLayers from "../components/RenderLayers/RenderLayers.jsx";
import MogrtGroup from "../components/MogrtGroup/MogrtGroup.jsx";
import BakeExpression from "../components/BakeExpression/BakeExpression.jsx";
import TrueBakeExpression from "../components/TrueBakeExpression/TrueBakeExpression.jsx";
import Pins3D from "../components/Pins3D/Pins3D.jsx";
import TransformPreCompose from "../components/TransformPreCompose/TransformPreCompose.jsx";
import UnPreComposeText from "../components/UnPreComposeText/UnPreComposeText.jsx";
import AutoMogrt from "../components/AutoMogrt/AutoMogrt.jsx";
import TransitionMogrt from "../components/TransitionMogrt/TransitionMogrt.jsx";
import Rename from "../components/Rename/Rename.jsx";
import ExportMotion from "../components/ExportMotion/ExportMotion.jsx";
import SlicedScale from "../components/SlicedScale/SlicedScale.jsx";
import ShapeGroupAnchor from "../components/ShapeGroupAnchor/ShapeGroupAnchor.jsx";
import BakeParent from "../components/BakeParent/BakeParent.jsx";
import NewTemplate from "../components/NewTemplate/NewTemplate.jsx";
import VideoBolt from "../components/VideoBolt/VideoBolt.jsx";
import IllustratorConvertToShape from "../components/IllustratorConvertToShape/IllustratorConvertToShape.jsx";
import ShapeMatte from "../components/ShapeMatte/ShapeMatte.jsx";
import ExportPremiere from "../components/ExportPremiere/ExportPremiere.jsx";
import ExportPremiereBeta from "../components/ExportPremiereBeta/ExportPremiereBeta.jsx";
import ExportTemplateBeta2 from "../components/ExportTemplateBeta2/ExportTemplateBeta2.jsx";
import DisableAnimator from "../components/DisableAnimator/DisableAnimator.jsx";
import DisableUnsupportedEffects from "../components/DisableUnsupportedEffects/DisableUnsupportedEffects.jsx";
import ImportGraphics from "../components/ImportGraphics/ImportGraphics.jsx";
import AutoCrop from "../components/AutoCrop/AutoCrop.jsx";
import MaskConvert from "../components/MaskConvert/MaskConvert.jsx";
import ExportDavinci from "../components/ExportDavinci/ExportDavinci.jsx";
import ExportElementsDaVinci from "../components/ExportElementsDaVinci/ExportElementsDaVinci.jsx";
import FlipValue from "../components/FlipValue/FlipValue.jsx";
import AutoCamera from "../components/AutoCamera/AutoCamera.jsx";
import ReverseKeyMotion from "../components/ReverseKeyMotion/ReverseKeyMotion.jsx";
import BakeProperty from "../components/BakeProperty/BakeProperty.jsx";
import MergeTextLayers from "../components/MergeTextLayers/MergeTextLayers.jsx";
import ShapeToBezierPath from "../components/ShapeToBezierPath/ShapeToBezierPath.jsx";
import AutoColorsScheme from "../components/AutoColorsScheme/AutoColorsScheme.jsx";
import ParallaxAnimator from "../components/ParallaxAnimator/ParallaxAnimator.jsx";
import ExpressionControls from "../components/ExpressionControls/ExpressionControls.jsx";
import BakeShapeLayers from "../components/BakeShapeLayers/BakeShapeLayers.jsx";
import RenderComps from "../components/RenderComps/RenderComps.jsx";
import RenderImportFootage from "../components/RenderImportFootage/RenderImportFootage.jsx";
import Space3D from "../components/Space3D/Space3D.jsx";
import MacroIcons from "../components/MacroIcons/MacroIcons.jsx";
import TitlesMogrt from "../components/TitlesMogrt/TitlesMogrt.jsx";
import ShapeToImage from "../components/ShapeToImage/ShapeToImage.jsx";
import TransitionsDropZone from "../components/TransitionsDropZone/TransitionsDropZone.jsx";
import ReviewTools from "../components/ReviewTools/ReviewTools.jsx";
import Grid from "../components/Grid/Grid.jsx";
import FillPlaceholders from "../components/FillPlaceholders/FillPlaceholders.jsx";
import SmartPreview from "../components/SmartPreview/SmartPreview.jsx";
import ColorsSchemes from "../components/ColorsSchemes/ColorsSchemes.jsx";
import FollowLayer from "../components/FollowLayer/FollowLayer.jsx";
import CollectFiles from "../components/CollectFiles/CollectFiles.jsx";
import ExportMogrt from "../components/ExportMogrt/ExportMogrt.jsx";
import ExportMogrtAdobe from "../components/ExportMogrtAdobe/ExportMogrtAdobe.jsx";
import Collapse from "../components/Collapse/Collapse.jsx";
import NormalizeTrackMatte from "../components/NormalizeTrackMatte/NormalizeTrackMatte.jsx";
import AutoBeat from "../components/AutoBeat/AutoBeat.jsx";
import AddControl from "../components/AddControl/AddControl.jsx";
import ExportGraphics from "../components/ExportGraphics/ExportGraphics.jsx";
import CreatePlaceholder from "../components/CreatePlaceholder/CreatePlaceholder.jsx";
import ResponsiveText from "../components/ResponsiveText/ResponsiveText.jsx";
import MaskToComp from "../components/MaskToComp/MaskToComp.jsx";
import SplitTextLayer from "../components/SplitTextLayer/SplitTextLayer.jsx";
import TransitionPreview from "../components/TransitionPreview/TransitionPreview.jsx";
import SplitTemplate from "../components/SplitTemplate/SplitTemplate.jsx";
import BakePlaceholder from "../components/BakePlaceholder/BakePlaceholder.jsx";
import VideoboltValidator from "../components/VideoboltValidator/VideoboltValidator.jsx";
import Flicker from "../components/Flicker/Flicker.jsx";
import InsertText from "../components/InsertText/InsertText.jsx";
import RenderVideoMatte from "../components/RenderVideoMatte/RenderVideoMatte.jsx";
import SmartPreCompose from "../components/SmartPreCompose/SmartPreCompose.jsx";
import KeysShifter from "../components/KeysShifter/KeysShifter.jsx";
import LayersShifter from "../components/LayersShifter/LayersShifter.jsx";
import ReplaceExpression from "../components/ReplaceExpression/ReplaceExpression.jsx";
import TextAnimator from "../components/TextAnimator/TextAnimator.jsx";

const COMPONENTS = {
  ResolutionTools,
  ColorControls,
  ExportElementsPremiere,
  Markers,
  MotionAnimator,
  EaseAnimator,
  RandomAnimator,
  RenderLayers,
  MogrtGroup,
  BakeExpression,
  TrueBakeExpression,
  Pins3D,
  TransformPreCompose,
  UnPreComposeText,
  AutoMogrt,
  TransitionMogrt,
  Rename,
  ExportMotion,
  SlicedScale,
  ShapeGroupAnchor,
  BakeParent,
  NewTemplate,
  VideoBolt,
  IllustratorConvertToShape,
  ShapeMatte,
  ExportPremiere,
  ExportPremiereBeta,
  ExportTemplateBeta2,
  DisableAnimator,
  DisableUnsupportedEffects,
  ImportGraphics,
  AutoCrop,
  MaskConvert,
  ExportDavinci,
  ExportElementsDaVinci,
  FlipValue,
  AutoCamera,
  ReverseKeyMotion,
  BakeProperty,
  ShapeToBezierPath,
  AutoColorsScheme,
  ParallaxAnimator,
  ExpressionControls,
  BakeShapeLayers,
  RenderImportFootage,
  Space3D,
  MacroIcons,
  TitlesMogrt,
  ShapeToImage,
  TransitionsDropZone,
  ReviewTools,
  Grid,
  FillPlaceholders,
  SmartPreview,
  ColorsSchemes,
  FollowLayer,
  CollectFiles,
  ExportMogrt,
  ExportMogrtAdobe,
  Collapse,
  NormalizeTrackMatte,
  AutoBeat,
  AddControl,
  ExportGraphics,
  CreatePlaceholder,
  ResponsiveText,
  MaskToComp,
  SplitTextLayer,
  TransitionPreview,
  SplitTemplate,
  // BakePlaceholder,
  VideoboltValidator,
  Flicker,
  InsertText,
  RenderVideoMatte,
  SmartPreCompose,
  RenderComps,
  MergeTextLayers,
  KeysShifter,
  LayersShifter,
  ReplaceExpression,
  TextAnimator
};

export default COMPONENTS;
